// Dispatch palette. Status colors are semantic (one hue per stage); age colors
// say how worried to be about an order. Brand red/green are used sparingly.

export const C = {
  page: '#f7f8fa',
  card: '#ffffff',
  subtle: '#fafbfc',
  border: '#e6e8ec',
  borderSoft: 'rgba(230, 232, 236, 0.7)',
  input: '#d5d9e0',
  text: '#101828',
  muted: '#5d6679',
  faint: '#98a2b3',
  mutedBg: '#f2f4f7',
  ink: '#16181d',
  brandRed: '#ff3008',
  brandGreen: '#2e7d32',
  danger: '#d92d20',
  sky: '#0369a1',
  skyBg: 'rgba(14, 165, 233, 0.1)',
}

export const TONE = {
  new: { fg: '#1d4ed8', bg: '#eef4ff', dot: '#1d4ed8' },
  accepted: { fg: '#4338ca', bg: '#eff0fe', dot: '#4338ca' },
  prepared: { fg: '#b54708', bg: '#fff6e6', dot: '#b54708' },
  assigned: { fg: '#6d28d9', bg: '#f5f0ff', dot: '#6d28d9' },
  transit: { fg: '#0e7490', bg: '#e7f9fc', dot: '#0e7490' },
  delivered: { fg: '#067647', bg: '#ebfaf1', dot: '#067647' },
  cancelled: { fg: '#5d6679', bg: '#f2f4f7', dot: '#d92d20' },
  muted: { fg: '#5d6679', bg: '#f2f4f7', dot: '#98a2b3' },
}

export const AGE = {
  fresh: { bar: '#17b26a', ink: '#067647', bg: '#ecfdf3' },
  warn: { bar: '#f79009', ink: '#b54708', bg: '#fffaeb' },
  late: { bar: '#f04438', ink: '#b42318', bg: '#fef3f2' },
  stale: { bar: '#b0b7c3', ink: '#5d6679', bg: '#f2f4f7' },
  scheduled: { bar: '#c4b5fd', ink: '#6d28d9', bg: '#f5f0ff' },
  done: { bar: 'transparent', ink: '#5d6679', bg: 'transparent' },
}

export const FONT = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
export const MONO = '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace'

export const tnum = { fontVariantNumeric: 'tabular-nums' }

/** Shared look for small outlined controls in the toolbar. */
export const controlSx = {
  height: 32,
  px: 1.25,
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: 13,
  fontWeight: 500,
  color: C.text,
  borderColor: C.border,
  bgcolor: C.card,
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  '&:hover': { bgcolor: C.mutedBg, borderColor: C.input, boxShadow: 'none' },
}

export const primaryButtonSx = {
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '8px',
  bgcolor: C.ink,
  color: '#fff',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#000', boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: C.mutedBg, color: C.faint },
}
